import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
    main: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
        paddingTop: theme.spacing(12),
        boxSizing: 'border-box',
        backgroundColor: '#eef3ef',
        [theme.breakpoints.down('sm')]: {
            paddingTop: 0,
            backgroundColor: '#eef3ef',
        },
    },
    content: {
        padding: theme.spacing(3),
        height: '100%',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2),
        },
    },
}));

export default function Content({ children }) {

    const classes = useStyles();

    return (
        <main className={classes.main}>
            <Grid container className={classes.content} alignItems="flex-start">
                {children}
            </Grid>
        </main>
    );
}
